const BlogFeaturesCard = ({
  index,
  button,
  handleInputChange,
  errors,
  removeButton,
  isEditable,
}) => {
  return (
    <>
      <div className="bg-white border border-black-600 rounded-[5px] px-4 py-4">
        <label className="inline-block mb-2 text-base font-medium">Label</label>
        <input
          type="text"
          value={button.label}
          disabled={!isEditable}
          onChange={(e) => handleInputChange(index, "label", e.target.value)}
          className="mb-2 form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
          placeholder="Enter Label"
        />
        {errors.buttons[index]?.label && (
          <p className="text-sm text-red-500">{errors.buttons[index].label}</p>
        )}
        <label className="inline-block mb-2 text-base font-medium">Value</label>
        <input
          type="text"
          disabled={!isEditable}
          value={button.value}
          onChange={(e) => handleInputChange(index, "value", e.target.value)}
          className="mb-2 form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
          placeholder="Enter Value"
        />
        {errors.buttons[index]?.value && (
          <p className="mt-2 text-red-500">{errors.buttons[index].value}</p>
        )}
        <div className="flex justify-end mt-2">
          <button
            onClick={!isEditable ? () => removeButton(index) : null}
            className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
          >
            Remove
          </button>
        </div>
      </div>
    </>
  );
};

export default BlogFeaturesCard;
